import { render, staticRenderFns } from "./PlatformLatestPostsCard.vue?vue&type=template&id=4909c83e"
import script from "./PlatformLatestPostsCard.vue?vue&type=script&lang=ts"
export * from "./PlatformLatestPostsCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports